import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { CategoryDTO } from '../../../api/category-api';
import SvgClose from '../../../assets/icons/Close';
import SvgDelete from '../../../assets/icons/Delete';
import SvgSave from '../../../assets/icons/Save';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';

interface SaveCategoryModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedCategory?: CategoryDTO;
    onHide: () => void;
    onSave: (values: CategoryDTO) => void;
    onDelete?: (category: CategoryDTO) => void;
}

export function SaveCategoryModal({
    show,
    allowEdit,
    selectedCategory,
    onHide,
    onSave,
    onDelete,
}: SaveCategoryModalProps) {
    const CategorySchema = yup.object().shape({
        code: yup.string().required(' '),
        title: yup.string(),
    });

    const defaultValues: CategoryDTO = {
        code: selectedCategory ? selectedCategory.code : '',
        title: selectedCategory ? selectedCategory.title : '',
    };

    if (!show) return <></>;

    return (
        <Formik initialValues={defaultValues} validationSchema={CategorySchema} onSubmit={onSave}>
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedCategory ? 'edit-category' : 'new-category'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedCategory && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedCategory)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="code"
                                name="code"
                                readOnly={!allowEdit || !!selectedCategory}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="title"
                                name="title"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
